import './styles/Selector.css'
import './styles/SelectorAdmin.css'
import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
// import { colourOptions } from '../data';
import data_ubi from './ubicaciones'
import { useFetch } from '../hooks/useFetch'
const MultiSelector=({index,opGeneral,placeholder,txtOpGen,opt_de,titulo,data,loading,selectFunction,origen})=>{
    // console.log(opt_de)
    const animatedComponents = makeAnimated();
    const customStyles = {
        menuPortal: base => ({
            ...base,
            maxHeight: '50px',
            zIndex: 9999 // Ajusta el z-index según sea necesario
          }),
        // Estilos para el contenedor del react-select
        control: (provided, state) => ({
          ...provided,
          color:'#003757',
          borderColor: state.isFocused ? '#80bdff' : '#ccc',
          boxShadow: state.isFocused ? '0 0 0 1px #80bdff' : null,
          '&:hover': {
            borderColor: state.isFocused ? '#80bdff' : '#999',
          },
        }),
        // Estilos para las opciones en el menú desplegable
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? '#80bdff' : null,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#aa9c9c', // Color deseado para el placeholder
          }),
      };
    const opt_default=(opGeneral)?[{ dispId: 0, name: txtOpGen ,id:0}]:[]
    const data_aux=opt_default.concat(data)
//    console.log(data_aux)
    let cont_i=0;
    let opcion_default=0
    const options=loading?{filter:titulo, value: 0, label: 'cargando...' ,id:0}:data_aux.map(datas=>{
        // console.log(datas)
        if(opt_de==0){
            // console.log("es 0")
            opcion_default=0
        }else{
            // console.log(datas)
            if(datas.id==opt_de){
                // console.log(" el valor es" ,cont_i)
                opcion_default=cont_i
            }
        }
        
        cont_i++
        let op;
        switch(titulo){
            case 'Municipio': op={ filter:titulo,value: datas.groupid === undefined?0:datas.groupid , label: datas.name ,id:datas.id};
                                break;
            case 'Tecnología': op={ filter:titulo,value: datas.dispId=== undefined?0:datas.dispId, label: datas.name ,id:datas.id};
                                break; 
            case 'Marca': op={ filter:titulo,value: datas.brand_id=== undefined?0:datas.brand_id, label:datas.value,id:datas.id};
                                break;  
            case 'Modelo': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.value ,id:datas.id};
                                break;  
            case 'CIS': op={ filter:titulo,value: datas.element_id=== undefined?0:datas.element_id, label: datas.folio ,id:datas.element_id};
                                break; 
            case 'statusConf': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name ,id:datas.id};
                                break;           
            case 'CisTec': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.value ,id:datas.id};
                                break;     
            case 'Proxys': op={ filter:titulo,value: datas.proxyid=== undefined?0:datas.proxyid, label: datas.host ,id:datas.proxyid};
                                break; 
            case 'Estados': op={ filter:titulo,value: datas.id, label: datas.name ,id:datas.id};
                                break; 
            case 'Agencia': op={ filter:titulo,value: datas.exception_agency_id=== undefined?0:datas.exception_agency_id, label: datas.name ,id:datas.id};
                                break; 
            case 'Severity': op={ filter:titulo,value: datas.cassia_criticality_id=== undefined?0:datas.cassia_criticality_id, label: datas.name ,id:datas.id};
                                break; 
            case 'Marcas': op={ filter:titulo,value: datas.brand_id=== undefined?0:datas.brand_id, label: datas.name_brand ,id:datas.brand_id};
                                break;   
            case 'hostModel': op={ filter:titulo,value: datas.model_id=== undefined?0:datas.model_id, label: datas.name_model ,id:datas.model_id};
                                break;   
            case 'techDevices': op={ filter:titulo,value: datas.dispId=== undefined?0:datas.dispId, label: datas.name ,id:datas.dispId};
                                break;
            case 'proxy': op={ filter:titulo,value: datas.proxy_id=== undefined?0:datas.proxy_id, label: datas.proxy_name ,id:datas.proxy_id};
                                break;      
             case 'Grupos': op={ filter:titulo,value: datas.groupid=== undefined?0:datas.groupid, label: datas.group_name ,id:datas.groupid};
                                break;   
            case 'zona': op={ filter:titulo,value: datas.groupid=== undefined?0:datas.groupid, label: datas.group_name ,id:datas.groupid};
                                break;   
            case 'Usuarios': op={ filter:titulo,value: datas.user_id=== undefined?0:datas.user_id, label: datas.name ,id:datas.user_id};
                                break;    
            case 'Hosts': op={ filter:titulo,value: datas.hostid=== undefined?0:datas.hostid, label: datas.name ,id:datas.hostid};
                                break;    
            case 'telegram': op={ filter:titulo,value: datas.groupid=== undefined?0:datas.groupid, label: datas.name ,id:datas.groupid};
                                break;     
            case 'typeGroup': op={ filter:titulo,value: datas.value=== undefined?0:datas.value, label: datas.value,id:datas.value};
                                break; 
            case 'services_catalog': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.service_name,id:datas.id};
                                break;   
            case 'groups_catalog': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name,id:datas.id};
                                break;
            case 'subgroups_catalog': op={ filter:titulo,value: datas.id=== undefined?0:datas.id, label: datas.name,id:datas.id};
                                break;     
            case 'field_option': op={ filter:titulo,value: datas.value, label: datas.label,id:datas.value};    
             break;                                                               
            default:
                op={ value: '', label: '' };
                    break;                        
        }
        return op                           // <option key={datas.uuid}> {datas.name} </option>
})
// console.log(options[opcion_default])
// console.log(options[opcion_default].label)
//console.log(options)
//console.log(opt_de)
    
    
    
    const [value,setValue]=useState([])
    
    // //console.log(value,'value') 
    const HandleChange=(selected,name)=>{
        // console.log(selected)
        // setValue((state)=>({
        //     ...state,[name]:selected.label
        // }))
        setValue(selected)
        selectFunction(selected,index,titulo)
        // if(origen==='mapa'){
        //     switch(selected.filter){
        //         case 'Municipio': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:selected.value,dispId:props.ubicacion.dispId,templateId:props.ubicacion.templateId})
        //                             break;
        //         case 'Tecnología': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:selected.value,templateId:props.ubicacion.templateId})
        //                             break; 
        //         case 'Métrica': props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId:selected.value})
        //                             break;                    
        //         default:
        //                 break;                        
        //     }
        // }else if(origen==='admin'){
        //         //console.log("admin",selected.value)
        // }
        
        
    }
    const colourOptions = [
        { value: 'ocean', label: 'Ocean', color: '#00B8D9', isFixed: true },
        { value: 'blue', label: 'Blue', color: '#0052CC', isDisabled: true },
        { value: 'purple', label: 'Purple', color: '#5243AA' },
        { value: 'red', label: 'Red', color: '#FF5630', isFixed: true },
        { value: 'orange', label: 'Orange', color: '#FF8B00' },
        { value: 'yellow', label: 'Yellow', color: '#FFC400' },
        { value: 'green', label: 'Green', color: '#36B37E' },
        { value: 'forest', label: 'Forest', color: '#00875A' },
        { value: 'slate', label: 'Slate', color: '#253858' },
        { value: 'silver', label: 'Silver', color: '#666666' },
      ];
    //   console.log(titulo)
    //   console.log(opt_de)
    //   console.log(options)
    // const targetElement = document.getElementById('content-menu-search');
    return(
        <div className='menuSearchOptionGS' style={{padding:'unset'}}>
            <div className={origen==='mapa'?'compactSelector':'compactSelectorAdminGS'}>
                        <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                defaultValue={(opt_de.length==0)?[]:options.filter(item => opt_de.includes(item.value))}
                // defaultValue={[options[4], options[5]]}
                isMulti
                options={options}
                // value={(value.length===0)?colourOptions[opcion_default]:value}
              className="react-multi-select-container-admin-gs"
                            classNamePrefix="react-multi-select-admin-gs"
                noOptionsMessage={() => "No existe"}
                onChange={(selected)=>HandleChange(selected,titulo)}
                placeholder={placeholder}
                // styles={customStyles}
    />
                {/* {
                    
                        origen==='mapa'?
                            <Select
                            options={options}
                            value={(value.length===0)?options[opcion_default]:value}
                            // options={{filter:titulo, value: 0, label: 'cargando...' }}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            onChange={(selected)=>HandleChange(selected,titulo)}
                            // placeholder={loading?'cargando..':placeholder}
                            // placeholder={'hola'}
                            noOptionsMessage={() => "No existe"}
                            isDisabled={loading}
                        />
                        :
                        <Select
                            options={options}
                            styles={customStyles}
                            // menuPortalTarget={targetElement}
                            // options={{filter:titulo, value: 0, label: 'cargando...' }}
                            value={(value.length===0)?options[opcion_default]:value}
                            className="react-select-container-admin-gs"
                            classNamePrefix="react-select-admin-gs"
                            onChange={(selected)=>HandleChange(selected,titulo)}
                            placeholder={(placeholder=="" || placeholder==undefined)?(loading?'cargando..':titulo):placeholder}
                            // placeholder="hola"
                            noOptionsMessage={() => "No existe"}
                            isDisabled={loading}
                        />
                        
                } */}
                
                
            </div>
        </div>
    )
}

export default MultiSelector